import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect, useState, useCallback } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { getAdminCredentials, getAdminById } from "../../../api/AdminApi";
import { useDispatch } from "react-redux";
import { LOGOUT_ACTION } from "../../../store/actions/AuthActions";
import { canAccess } from "../../../utils/permissions";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() { }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = (props) => {
  const { iconHover, sidebarposition, headerposition, sidebarLayout } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [hideOnScroll, setHideOnScroll] = useState(true);

  const assigmentValue = useCallback(async () => {
    try {
      const credentials = await getAdminCredentials();
      const user = await getAdminById(credentials.IdUsuario);
      setUserData(user[0] || {});
    } catch (err) {
      console.error("Error fetching user data:", err);
      dispatch(LOGOUT_ACTION(props.history));
    }
  }, [dispatch, props.history]);

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const fullPath = window.location.pathname;

  const isUsuarios = /^\/usuarios(\/|$)|\/fichausuario(\/|$)/.test(fullPath);
  const isClientes = /^\/clientes(\/|$)|\/Fichaclientes(\/|$)|\/Liquidacion(\/|$)/.test(fullPath);
  const isSesiones = /^\/sesiones(\/|$)|\/legajo(\/|$)/.test(fullPath);
  const isCierres = /^\/liquidaciones(\/|$)|^\/fichaliquidacion(\/|$)/.test(fullPath);
  const isOrdenDePago = /^\/ordendepago(\/|$)/.test(fullPath);
  const isPagos = /^\/pagos(\/|$)/.test(fullPath);
  const isOpciones = /^\/opciones(\/|$)/.test(fullPath);
  const isAdmin = /^\/admin(\/|$)/.test(fullPath);
  const isAlquileres = /^\/alquileres(\/|$)/.test(fullPath);
  const isInventario = /^\/inventario(\/|$)/.test(fullPath);

  return (
    <div
      className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
        }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <MM className="metismenu" id="menu">
          {canAccess(userData, "cuentas") && (
            <li className={isUsuarios ? "mm-active" : ""}>
              <Link to="/usuarios" className="ai-icon">
                <i className="material-icons"> person </i>
                <span className="nav-text">Cuentas</span>
              </Link>
            </li>
          )}
          {canAccess(userData, "usuarios") && (
            <li className={isClientes ? "mm-active" : ""}>
              <Link to="/clientes" className="ai-icon">
                <i className="material-icons"> person_add </i>
                <span className="nav-text">Usuarios</span>
              </Link>
            </li>
          )}
          {canAccess(userData, "operaciones") && (
            <>
              <li className={isSesiones ? "mm-active" : ""}>
                <Link to="/sesiones" className="ai-icon">
                  <i className="material-icons"> check_circle </i>
                  <span className="nav-text">Operaciones</span>
                </Link>
              </li>
            </>
          )}
          {canAccess(userData, "cierres") && (
            <li className={isCierres ? "mm-active" : ""}>
              <Link to="/liquidaciones" className="ai-icon">
                <i className="material-icons"> description </i>
                <span className="nav-text">Cierres</span>
              </Link>
            </li>
          )}
          {canAccess(userData, "appClientes") && (
            <li className={fullPath.startsWith("/appclientes") ? "mm-active" : ""}>
              <Link to="/appclientes" className="ai-icon">
                <i className="material-icons"> smartphone </i>
                <span className="nav-text">App Clientes</span>
              </Link>
            </li>
          )}

          {canAccess(userData, "inventario") && (
            <li className={isInventario ? "mm-active" : ""}>
              <Link to="/inventario" className="ai-icon">
                <i className="material-icons"> inventory_2 </i>
                <span className="nav-text">Inventario</span>
              </Link>
            </li>
          )}

          {canAccess(userData, "alquileres") && (
            <li className={isAlquileres ? "mm-active" : ""}>
              <Link to="/alquileres" className="ai-icon">
                <i className="material-icons"> business </i>
                <span className="nav-text">Alquileres</span>
              </Link>
            </li>
          )}

          {canAccess(userData, "ordenPago") && (
            <li className={isOrdenDePago ? "mm-active" : ""}>
              <Link to="/ordendepago" className="ai-icon">
                <i className="material-icons"> payment </i>
                <span className="nav-text">Ordenes de Pagos</span>
              </Link>
            </li>
          )}
          {canAccess(userData, "pagos") && (
            <li className={isPagos ? "mm-active" : ""}>
              <Link to="/pagos" className="ai-icon">
                <i className="material-icons"> payments </i>
                <span className="nav-text">Pagos</span>
              </Link>
            </li>
          )}
          {canAccess(userData, "opciones") && (
            <li className={isOpciones ? "mm-active" : ""}>
              <Link to="/opciones" className="ai-icon">
                <i className="material-icons"> settings </i>
                <span className="nav-text">Opciones</span>
              </Link>
            </li>
          )}
          {(userData.IdTipoUsuario === "0" || userData.IdTipoUsuario === "2") && (
            <li className={isAdmin ? "mm-active" : ""}>
              <Link to="/admin" className="ai-icon">
                <i className="material-icons"> manage_accounts </i>
                <span className="nav-text">Admin</span>
              </Link>
            </li>
          )}
        </MM>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
